import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';

import BlanketStore from './blanketStore';
import DrawerStore from './drawerStore';
import FeatureFlagsStore from './featureFlagsStore';
import FlagStore from './flagStore';
import ProductStore from './productStore';
import UIStore from './uiStore';
import UserStore from './userStore';

export default interface Store {
  blanketStore: BlanketStore;
  drawerStore: DrawerStore;
  featureFlagsStore: FeatureFlagsStore;
  flagStore: FlagStore;
  productStore: ProductStore;
  uiStore: UIStore;
  userStore: UserStore;
}

export const useStore = <K extends keyof Store>(store: K): Store[K] => {
  const stores = useContext(MobXProviderContext);

  return stores[store];
};

export const createStore = (): Store => {
  const featureFlagsStore = new FeatureFlagsStore();
  const userStore = new UserStore();
  const productStore = new ProductStore(userStore);

  return {
    blanketStore: new BlanketStore(),
    drawerStore: new DrawerStore(),
    featureFlagsStore,
    flagStore: new FlagStore(),
    productStore,
    uiStore: new UIStore(),
    userStore,
  };
};
